import { Suspense } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { OfflineIndicator } from '../components/OfflineIndicator';
import { UpdatePrompt } from '../components/pwa/UpdatePrompt';
import { LoadingState } from '../components/ui/loading-state';

export function RootLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top-level pages are code-split; this catches chunk loads for routes
          that render outside the dashboard/lite shells (auth, public). */}
      <Suspense fallback={<LoadingState size="lg" className="min-h-screen" />}>
        <Outlet />
      </Suspense>
      {/* Client-side navigations keep the window's scroll offset, so a page
          opened from the bottom of a long list rendered mid-page (Jim,
          2026-09-04). This scrolls to top on new navigations, restores the
          saved position on back/forward, and honours #hash anchors. Kept
          outside the Suspense boundary so a chunk load can't unmount it. */}
      <ScrollRestoration />
      <OfflineIndicator />
      <UpdatePrompt />
    </div>
  );
}
